import { render, staticRenderFns } from "./CreateSnat.vue?vue&type=template&id=6561d30c"
import script from "./CreateSnat.vue?vue&type=script&lang=js"
export * from "./CreateSnat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports